import { Injectable } from '@angular/core';
import { WrapperService } from './wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class MasterService extends WrapperService {

  getRegisterContents(onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get('/api/v1/notification/fetch?limit=100')
    .subscribe(
      resp => {
        onSuccess(resp.items);
      },
      err => {
        if (onError) {
          onError(err);
        }
      });
  }

  getTermsAndConditions(
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.get('/api/v1/terms-and-conditions/fetch')
    .subscribe(
      resp => {
        onSuccess(resp);
      },
      err => {
        if (onError) {
          onError(err);
        }
      });
  }

  getBusinessTypes(onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get('/api/v1/jenis-usaha/fetch?limit=100')
    .subscribe(
      resp => {
        onSuccess(resp.items);
      },
      err => {
        if (onError) {
          onError(err);
        }
      });
  }

  getProvinces(onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get('/api/v1/region/province/fetch')
    .subscribe(
      resp => {
        onSuccess(resp);
      },
      err => {
        if (onError) {
          onError(err);
        }
      });
  }

  getRegencies(provinceID: string, onSuccess: (data) => void, onError: (data) => void = null): any {
    let segmentURL = `/api/v1/region/regency/fetch${provinceID ? "?provinceId="+provinceID:""}`
    this.get(segmentURL)
    .subscribe(
      resp => {
        onSuccess(resp);
      },
      err => {
        if (onError) {
          onError(err);
        }
      });
  }

  getDistricts(regencyID: string, onSuccess: (data) => void, onError: (data) => void = null): any {
    let segmentURL = `/api/v1/region/district/fetch${regencyID ? "?regencyId="+regencyID:""}`
    this.get(segmentURL)
    .subscribe(
      resp => {
        onSuccess(resp);
      },
      err => {
        if (onError) {
          onError(err);
        }
      });
  }

  getVillages(districtID: string, onSuccess: (data) => void, onError: (data) => void = null): any {
    let segmentURL = `/api/v1/region/village/fetch${districtID ? "?districtId="+districtID:""}`
    this.get(segmentURL)
    .subscribe(
      resp => {
        onSuccess(resp);
      },
      err => {
        if (onError) {
          onError(err);
        }
      });
  }

  getPostalCodes(districtID: string, villageName: string, onSuccess: (data) => void, onError: (data) => void = null): any {
    let segmentURL = `/api/v1/region/village/fetch?districtId=${districtID}&villageName=${villageName}`
    this.get(segmentURL)
    .subscribe(
      resp => {
        onSuccess(resp);
      },
      err => {
        if (onError) {
          onError(err);
        }
      });
  }

  getPaymentChannels() {
    return this.get("/api/v1/payment-channel/fetch")
  }

  getPopupMessageDetail(code: string) {
    return this.get(`/api/v1/pop-up-message/detail?code=${code}`)
  }
}
